import { render, staticRenderFns } from "./newsPager.vue?vue&type=template&id=60c4a7a6"
import script from "./newsPager.vue?vue&type=script&lang=js"
export * from "./newsPager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports